import React from 'react';
import { Icon, IconColorOptions } from '../Icon';

import './styles.scss';

interface Props {
    text: string;
    type?: 'warn' | 'default';
    icon?: string;
    className?: string;
    style?: React.CSSProperties;
}

export const Alert = ({ text, type = 'default', icon, className = '', ...props }: Props) => {
    const getIconColor = (): IconColorOptions => {
        switch (type) {
            case 'warn':
                return 'warn';
            case 'default':
            default:
                return 'default';
        }
    };

    const getColorClassName = (): string => {
        switch (type) {
            case 'warn':
                return 'app-alert--warn';
            case 'default':
            default:
                return '';
        }
    };
    return (
        <div className={`app-alert ${className} ${getColorClassName()}`} {...props}>
            {icon && <Icon icon={icon} color={getIconColor()} className='app-alert__icon' />}
            <span className='app-alert__text'>{text}</span>
        </div>
    );
};
